import React, { Component } from 'react'
import '../udi/outStockConfig.less'
import "@/static/style/margin.less"
import "@/static/style/init.less"
import "@/static/style/common.less"
import { Button, Table, message, Modal, Input, Select, Upload, Pagination, Radio, Spin } from 'antd'
import _, { get,set } from 'lodash'
import { ajaxApi, downloadApi } from '@/server/index'
import moment from 'moment'
import common from "@/public/common";
import {  getCookie, tokenConfig } from '@/public/utils'


var apiHost =  common.SapUrl

class list extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            params: {
                "s_code": getCookie('supplier_code')||'',
                "sigo_name": "",
                "supplier_product_code": "",
                "page_index": 1,
                "page_size": 10,
            },
            data: [],
            supplierList: [],
            codeList: [],
            columns: [
                {
                    title: '视客商品编码',
                    key: "item_code",
                    dataIndex: "item_code",
                    align: 'center',
                },
                {
                    title: "视客商品名称",
                    key: "item_name",
                    dataIndex: "item_name",
                    align: 'center',
                },
                {
                    title: "视客商品类别",
                    key: "category_name",
                    dataIndex: "category_name",
                    align: 'center',
                },
                {
                    title: "品牌",
                    key: "brand_name",
                    dataIndex: "brand_name",
                    align: 'center',
                },
                {
                    title: "货品编码关系对照",
                    key: "adjustNo",
                    dataIndex: "adjustNo",
                    align: 'center',
                    render: (text, record) => {
                        return (
                            <span>
                                <a onClick={() => { this.toDetailPage(record) }}>查看</a>
                            </span>
                        )
                    }
                },
            ],
            errorModalData: [],
            errModalVisible: false,
        };
    }

    toDetailPage = (record) => {
        const url = `${'/main/commoditymanagement/productCatalogsDetail'}${'?item_code='}` + get(record, 'item_code')
        window.open(url)
    }


    componentDidMount() {
        _.defer(this.getTableData, 1000)
    }

    search = async () => {
        let { params } = this.state
        set(params, 'page_index', 1)
        this.setState({ params })
        _.defer(this.getTableData, 1000)
    }


    getTableData = async () => {
        this.changeLoading(true)
        try {
            let { params } = this.state
            const res = await ajaxApi({
                url: `${apiHost}supplier-item/query-list`,
                params,
            });
            set(params, 'total', get(res, 'data.data.total_size', 0))
            this.setState({
                data: get(res, 'data.data.data', []),
                params
            })
            this.changeLoading(false)
        } catch (err) {
            this.changeLoading(false)
        }
    }

    getSid = () => {
        return getCookie('sid') || null
    }

    changeLoading = (loading) => {
        this.setState({ loading })
    }


    iptChange = (e) => {
        let { params } = this.state
        set(params, e.target.name, e.target.value.trim())
        this.setState({
            params
        })
    }


    selectChange = (key, value) => {
        let { params } = this.state
        set(params, key, value)
        this.setState({
            params
        })
    }

    exportExcel = () => {
        let { params } = this.state
        downloadApi(
            apiHost + '/supplier-item/download-product-relation',
            params,
            '供货商品目录' + moment().format('YYYYMMDDHHmmss') + '.xls'
        )
    }

    downloadTemplate = () => {
        downloadApi(
            apiHost + 'supplier-item/download-relation-template',
            null,
            '供货商品目录模板' + moment().format('YYYYMMDDHHmmss') + '.xls'
        )
    }


    getModerId = () => {
        var moder_id = getCookie('supplier_company_code') || null
        return moder_id
    }

    // 页数据修改
    onShowSizeChange = (current, pageSize) => {
        try {
            let { params } = this.state
            set(params, 'page_size', pageSize)
            set(params, 'page_index', current)
            this.setState({
                params
            }, () => {
                this.getTableData();
            });
        } catch (error) {
            console.log(error);
        }
    };


    handleCancel = () => {
        this.setState({
            lookVisible: false,
            errModalVisible: false
        })
    }




    render() {
        let {
            params, errorModalData
        } = this.state

        const personProps = {
            name: 'file',
            action: apiHost + 'supplier-item/upload-product-relation',
            headers:{...tokenConfig},
            data: (file) => {
                return {
                    admin_id: this.getModerId(),
                    "s_code": getCookie('supplier_code')||'',
                }
            },
            accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel",
            beforeUpload: file => {
                if (!['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'].includes(file.type)) {
                    message.error('请上传excel文件！')
                }
                return ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'].includes(file.type) ? true : Upload.LIST_IGNORE;
            },
            onChange: (info) => {
                if (info.file.status !== 'uploading') {
                    console.log(info.file, info.fileList);
                }
                if (info.file.status === 'done') {
                    var data = get(info, 'file.response.data')
                    if (get(data, 'data.length')) {
                        this.setState({
                            errorModalData: data,
                            errModalVisible: true
                        })
                    } else if (get(info, 'file.response.message')) {
                        message.success(get(info, 'file.response.message'))
                    } else {
                        message.success(`${info.file.name}导入成功`);
                        setTimeout(() => {
                            window.location.reload()
                        }, 1500)
                    }
                } else if (info.file.status === 'error') {
                    message.error(`${info.file.name}导入失败`);
                }

            },
        }
        return (
            <div className='purchaseAdjustList outStockConfig'>
                <section className="search mb20" >
                    {/* <h3>供货商品目录</h3> */}
                    <span>视客商品/货品：</span>
                    <Input
                        placeholder="请输入编码或名称"
                        className='width_200_input mr12'
                        onChange={this.iptChange}
                        name='sigo_name'
                        value={get(params, 'sigo_name')}
                    />
                    <span className='ml16'>供应商货品：</span>
                    <Input
                        placeholder="请输入"
                        className='width_200_input mr12'
                        onChange={this.iptChange}
                        name='supplier_product_code'
                        value={get(params, 'supplier_product_code')}
                    />
                    <div className='floatRight'>
                        <Button type="primary" className='mr16' onClick={this.search}>查询</Button>
                        <Button className='mr16' onClick={() => { window.location.reload() }}>重置</Button>
                        <Button type='primary' onClick={this.exportExcel}>导出</Button>
                        <span className={'noProgressUplaod'}>
                            <Upload {...personProps} >
                                <Button className={'ml16'}>Excel导入</Button>
                            </Upload>
                        </span>
                        <a className='ml16' onClick={this.downloadTemplate}>下载模板</a>
                    </div>

                </section>
                <Spin spinning={this.state.loading} >
                    <div style={{ overflow: 'hidden' }} className='tableBody'>
                        <Table
                            columns={this.state.columns}
                            dataSource={this.state.data}
                            pagination={false}
                        ></Table>
                        <div style={{ float: 'right' }} className='mt20'>
                            <Pagination
                                current={get(params, 'page_index')}
                                showQuickJumper
                                total={get(params, 'total')}
                                pageSize={get(params, 'page_size')}
                                showSizeChanger
                                showTotal={() => {
                                    return <span style={{ marginRight: '20px', float: 'left' }}>
                                        共{get(params, 'total')}条，每页{get(params, 'page_size')}条
                                    </span>
                                }}
                                onShowSizeChange={this.onShowSizeChange}
                                onChange={this.onShowSizeChange}
                            />
                        </div>
                    </div>
                </Spin>
                <Modal
                    title="导入结果"
                    visible={this.state.errModalVisible}
                    width={650}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" type="primary" onClick={this.handleCancel}>
                            我知道了
                        </Button>
                    ]}
                >
                    <div style={{ maxHeight: '300px', overflow: 'auto' }}>
                        <div style={{ color: '#1890ff', fontWeight: 550 }}>
                            共处理{get(errorModalData, 'total_size')}条数据，{get(errorModalData, 'success_size')}条成功，<span style={{ color: 'red' }}>其中有{get(errorModalData, 'fail_size')}条数据导入失败：</span>
                        </div>
                        {
                            (get(errorModalData, 'data') || []).map((item, index) => {
                                return (
                                    <div key={index} style={{ marginTop: "8px" }}>{item}</div>
                                )
                            })
                        }
                    </div>
                </Modal>
            </div>
        );
    }
}

export default list



// WEBPACK FOOTER //
// ./src/pages/commoditymanagement/productCatalogs.js